jQuery(document).ready(function($){

  /* birthday at register */
  $('body').on('input', '#113635', function(e) {
    var inputValue = $(this).val();
    inputValue = inputValue.replace(/[^0-9\/]/g, '');

    if(e.originalEvent.inputType != 'deleteContentBackward'){
      if(inputValue.length === 2 && inputValue.indexOf('/') === -1){
        inputValue += '/';
      }
    }
    else{
      if(inputValue.length === 2){
        inputValue = inputValue.slice(0, -1);
      }
    }

    var month = inputValue.substring(0, 2);
    var day = inputValue.substring(3, 5);

    if(parseInt(month) > 12){
      inputValue = inputValue.slice(0, -2);
    }
    else if(month.length === 2 && parseInt(month) <= 0){
      inputValue = inputValue.slice(0, -2);
    }
    if(parseInt(day) > 31){
      inputValue = inputValue.slice(0, -1);
    }

    $(this).val(inputValue);
  });


})
